module.exports = __webpack_public_path__ + "img/logo_hudie0@2x.f6a19220.png";